import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
  },
  card: {
    padding: '10px 0',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  heading: {
    padding: '0 15px 0 16px',
    fontWeight: 700,
    fontSize: 25,
    color: '#58595B',
    margin: '10px 0 10px 0',
  },
  cardActionButton: {
    padding: '15px 0 5px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '14px',
  },
  wrapper: {
    margin: 20,
    overflowX: 'auto',
    '&>*': {
      overflowX: 'auto',
    },
  },
  routeButtonsWrap: {
    margin: '0 20px',
    '& > button': {
      background: '#ccc',
      padding: '0 10px',
      borderRadius: 10,
      margin: '0 5px',
    },
    '& > .Mui-disabled': {
      color: '#fff',
      background: '#5AA600',
    },
    '& > button .MuiSvgIcon-root': {
      display: 'none',
    },
    '& > .Mui-disabled .MuiSvgIcon-root': {
      display: 'block',
    },
  },
  routeButtonsWrapMobile: {
    margin: '0 20px',
    '& > button': {
      background: '#ccc',
      padding: '10px 20px',
      borderRadius: 5,
      margin: '0 5px',
    },
    '& > .Mui-disabled': {
      color: '#fff',
      background: '#5AA600',
    },
    '& > button .MuiSvgIcon-root': {
      display: 'none',
    },
    '& > .Mui-disabled .MuiSvgIcon-root': {
      display: 'block',
    },
  },
  flex__container: {
    display: 'flex',
    flexWrap: 'wrap',
    '&#mobileHeader': {
      '& #mobileSearch': {
        [theme.breakpoints.down('sm')]: {
          display: 'block',
          transition: 'width 0.5s, height 0.5s, opacity 0.5s',
          width: 0,
          height: 0,
          opacity: 0,
          '& *:not(.MuiChip-root, .MuiSvgIcon-root)': {
            transition: 'width 0.5s, height 0.5s, opacity 0.5s',
            width: 0,
            height: 0,
            opacity: 0,
          },
          '& .MuiChip-root': {
            margin: '5%',
            display: 'none',
          },
          '&.open': {
            width: '65%',
            height: 'auto',
            opacity: 1,
            '& *:not(.MuiChip-root, .MuiSvgIcon-root)': {
              width: 'auto',
              opacity: 1,
              height: 'auto',
            },
            '& .MuiChip-root': {
              display: 'flex',
            },
          },
        },
      },
    },
  },
  dateInputFlex: {
    '&>*': {
      width: '90%',
    },
  },
  datePopup: {
    '& .MuiChip-root': {
      margin: '5% 5%',
    },
    '& .MuiFormControl-root': {
      margin: '3% 5%',
      '&:last-child': {
        marginBottom: '15%',
      },
    },
  },
  flex__item: {
    flexGrow: 1,
    margin: 20,
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#109CF1',
  },
  viewAllText: {
    fontSize: 11,
  },
  card__wrapper: {
    padding: '0 10px',
  },
  leadButton: {
    fontSize: '1rem',
  },
  leadsButtons: {
    marginTop: 50,
    '& .MuiButton-root': {
      width: '45%',
      margin: '2.5%',
      padding: '10px',
      '&:first-child': {
        background: theme.palette.primary.main,
        color: 'white',
      },
    },
  },
  addLeadPopup: {
    '& .MuiDialog-paperWidthSm': {
      width: '30%',
    },
    '& .MuiDialogTitle-root': {
      '& .MuiTypography-root': {
        fontWeight: 700,
        fontSize: 28,
        textAlign: 'center',
      },
    },
  },
  card__header: {
    display: 'flex',
    '&>*:first-child': {
      display: 'flex',
      alignItems: 'center',
      width: '40%',
    },
    '&>*:last-child': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: 20,
      width: '60%',
    },
    alignItems: 'center',
    paddingBottom: 10,

    '& .MuiChip-root': {
      height: 25,
    },
  },
  card__header_alone: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
    justifyContent: 'center',
    '& .MuiChip-root': {
      height: 25,
    },
  },
  chipMargin: {
    margin: '0 5px',
  },
  searchInput: {
    minWidth: 200,
    marginLeft: 10,
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      marginLeft: 0,
      paddingLeft: '5%',
      '& .MuiChip-root': {
        textAlign: 'center',
      },
    },
  },
  popUp: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30,
    backgroundColor: '#1C1A1A',
    padding: 10,
    position: 'fixed',
    bottom: 50,
    left: '35%',
    transform: 'translate(-50%, -50%)',
  },
  popUpMobile: {
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 16,
    backgroundColor: '#1C1A1A',
    width: '94%',
    margin: '10px auto 0 auto',
    height: 50,
  },
  popUpText: {
    color: 'white',
    fontSize: 13,
    marginRight: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  },
  loading: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blackLink: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
  },
  noContentBlock: {
    minHeight: 200,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rejectComment: {
    margin: '10px 24px',
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      borderColor: theme.palette.secondary.main,
    },
    '& label.Mui-focused': {
      color: theme.palette.secondary.main,
    },
  },
  approveComment: {
    margin: '10px 24px',
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      borderColor: '#00B4E0',
    },
    '& label.Mui-focused': {
      color: '#00B4E0',
    },
  },
  approvalText: {
    margin: 0,
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      color: 'white',
      fontSize: '1.5rem',
    },
  },
  select: {
    backgroundColor: theme.palette.primary.lighter,
    borderRadius: 15,
    width: '65%',
    opacity: 1,
    transition: 'width 0.5s, opacity 0.5s',
    marginLeft: '5%',
    height: '2.575rem',
    '& *': {
      maxHeight: '2.575rem',
      transition: 'width 0.5s',
    },
    '&.openSearch': {
      width: 0,
      opacity: 0,
      '& *': {
        width: 0,
        opacity: 0,
      },
    },
    '& .MuiInputBase-root': {
      color: 'white',
      textAlign: 'center',
      fontSize: '1.35rem',
      fontWeight: 700,
    },
    '& .MuiSelect-icon': {
      color: 'white',
      width: '2rem',
      height: '2rem',
      top: 'unset',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
  fullViewIcons: {
    color: '#586875',
    width: '12.5%',
    fontSize: 26,
    margin: 0,
    textAlign: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '2.2rem',
      height: '100%',
    },
  },
  leadTable: {
    display: 'block',
    maxWidth: '100%',
  },
  sortIcon: {
    marginLeft: 10,
    '&.asc': {
      transform: 'rotate(180deg)',
    },
  },
}));

export default useStyles;
